/**
 * Open/close state for the desktop header search field.
 *
 * The results panel is rendered by Horizon's `<predictive-search-component>`;
 * this element only decides when it is on screen. It deliberately does NOT
 * close on blur: in some browsers clicking a link does not focus it, so a
 * focus-based rule hides the panel on mousedown and the click never lands.
 * Closing on outside pointerdown keeps clicks inside the panel safe.
 */
class HeaderSearchInline extends HTMLElement {
  connectedCallback() {
    this.addEventListener('focusin', this.#open);
    this.addEventListener('input', this.#open);
    document.addEventListener('pointerdown', this.#handlePointerDown);
    document.addEventListener('keydown', this.#handleKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('focusin', this.#open);
    this.removeEventListener('input', this.#open);
    document.removeEventListener('pointerdown', this.#handlePointerDown);
    document.removeEventListener('keydown', this.#handleKeyDown);
  }

  #open = () => {
    this.dataset.open = 'true';
  };

  #close = () => {
    delete this.dataset.open;
  };

  /**
   * @param {PointerEvent} event
   */
  #handlePointerDown = (event) => {
    const target = event.target;
    if (target instanceof Node && this.contains(target)) return;
    this.#close();
  };

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeyDown = (event) => {
    if (event.key === 'Escape') this.#close();
  };
}

if (!customElements.get('header-search-inline')) {
  customElements.define('header-search-inline', HeaderSearchInline);
}
